import { AccessDenied, AppShell, Button, Spinner, ToastProvider } from '@rooming/ui';
import { appNameFor } from '@rooming/web-core';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { ActivationPage } from './pages/ActivationPage';
import { BoardPage } from './pages/BoardPage';
import { CredentialChangePage } from './pages/CredentialChangePage';
import { LoginPage } from './pages/LoginPage';
import { StaysPage } from './pages/StaysPage';
import { SessionProvider, useSession } from './session';

/** Routes are gated by the SERVER's view of the session (the cookie is HttpOnly); the API enforces it anyway. */
function Screens() {
  const { loading, stage, signOut } = useSession();
  const exit = (): void => void signOut();
  const active = stage === 'ACTIVE';
  return (
    <AppShell
      appName={appNameFor('Funtour · Habitaciones', window.location.hostname)}
      actions={
        active ? (
          <Button variant="ghost" onClick={exit}>
            Salir
          </Button>
        ) : undefined
      }
    >
      {loading ? (
        <Spinner />
      ) : stage === 'CREDENTIAL_CHANGE_PENDING' ? (
        <CredentialChangePage onSignOut={exit} />
      ) : !active ? (
        // The group's activation link (DR-405) is the one page reachable without a session besides the login. A staff
        // session (MFA_PENDING) has nothing to do here either: the backoffice is a different app.
        <Routes>
          <Route path="/activar" element={<ActivationPage />} />
          <Route path="*" element={<LoginPage />} />
        </Routes>
      ) : (
        <Routes>
          <Route path="/" element={<StaysPage />} />
          <Route path="/estadias/:stayId" element={<BoardPage />} />
          {/* The passenger app has no other page: anything typed by hand goes back home, saying why. */}
          <Route
            path="*"
            element={
              <AccessDenied>
                <Navigate to="/" replace />
              </AccessDenied>
            }
          />
        </Routes>
      )}
    </AppShell>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <SessionProvider>
          <Screens />
        </SessionProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}
